import React from 'react';
import LandingPage from './features/landingPage/LandingPage';

export default function App() {
  return (
    <LandingPage />
  );
}
